import React from "react";

const OrderSummary = ({ orderData, handleButtonClick, formStatus }) => {
  return (
    <div className="text-sm mt-4">
      <p className="mb-2 text-amber-500">
        <strong>Status:</strong> {orderData.status}
      </p>
      <p className="mb-2 text-amber-500">
        <strong>Order Date:</strong>{" "}
        {new Date(orderData.order_date).toLocaleString()}
      </p>
     
      <p className="mb-2">
        <strong>Total Price:</strong>{" "}
        <span className="text-green-500 font-bold text-xl">
          Rs: {orderData.price}
        </span>
      </p>
      <div className="">
        <button className="bg-amber-500 p-1" onClick={handleButtonClick}>
          Start Making
        </button>
        <p>{formStatus}</p>{" "}
      </div>
    </div>
  );
};

export default OrderSummary;





{/* <div className="container mx-auto py-8">
      <h2 className="text-4xl font-bold text-center text-white mb-8">Futuristic Bakery Products</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.map((product) => (
          <div key={product.id} className="bg-gray-800 rounded-lg overflow-hidden shadow-md">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-56 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="text-xl font-semibold text-white mb-2">{product.name}</h3>
              <p className="text-gray-400 mb-4">{product.description}</p>
              <div className="flex justify-between items-center">
                <span className="text-green-500 font-bold">${product.price}</span>
                <button className="bg-green-500 text-white px-4 py-2 rounded-full">Add to Cart</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div> */}